/**
 * The corresponding file upload state
 * @enum {string}
 */
export const FileUploadState = {
    Upload: "upload",
    Submit: "submit",
    Complete: "complete",
    Error: "error",
    SubmissionError: "submission-error",
    SubmissionWarning: "submission-warning"
};